module.exports = __webpack_public_path__ + "static/img/index.bae4c142.svg";